//in this file upload fucntionality have been deprecated
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
//import OutlinedInput from "@material-ui/core/OutlinedInput";
import Button from "@material-ui/core/Button";
//import FormGroup from "@material-ui/core/FormGroup";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import FilledInput from "@material-ui/core/FilledInput";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";

// @material-ui/icons components
import School from "@material-ui/icons/School";


import { Typography } from "@material-ui/core";
import componentStylesButtons from "assets/theme/components/button.js";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    // Add animation styles
    animation: `$sideUp 0.5s ease-out`,
    transform: "translateY(100%)",
    opacity: 0,
    animationFillMode: "forwards",
  },
  "@keyframes sideUp": {
    "0%": {
      transform: "translateY(100%)",
      opacity: 0,
    },
    "100%": {
      transform: "translateY(0)",
      opacity: 1,
    },
  },
  cardHeader: {
    textAlign: "center",
  },
  cardContent: {
    textAlign: "center",
  },
  buttonContainedInfo: {
    backgroundColor: theme.palette.info.main,
  },
}));

const useStylesButtons = makeStyles(componentStylesButtons);

function Delete() {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const theme = useTheme();
  const history = useHistory();
  const [alertText, setalertText] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);
  const [form, setform] = useState({
    course: "",
    description: "",

  });

  //text fields changes
  const handleChange = (e) => {
    setalertText("");
    setform((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  //upload file function
  const handleUpload = async () => {
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append('image', selectedFile);

    try {
      const response = await fetch('http://localhost:5000/upload', {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();
      console.log('Success:', data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  //handle file change save filename 
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(event.target.files[0]);

    form.filename=file.name

    
  };

  

  const ChangeCLick = () => {
    if (["course","courseteacher", "description"].some((field) => form[field] === "")) {
      setalertText("please fill all the fields");
      return;
    }

    var token = localStorage.getItem("token");

    const fetchCreate = async () => {
      try {
        const res = await fetch("https://server.thelanofficial.com/Create-Course", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            course: form.course,
            courseteacher: form.courseteacher,
            filename:form.filename,
            description:form.description,
            token,
          }),
        });

        if (!res.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await res.json();

        if (data.valid === false) {
          setalertText(data.message);
        } else if (data.valid === true) {
          setform((prev) => ({
            ...prev,
            [form.password]: "",
          }));
          setalertText(data.message);
         

        }
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    };

    fetchCreate();
   
  };

  useEffect(() => {
    var token = localStorage.getItem("token");

    const fetchData = async () => {
      try {
        const res = await fetch("https://server.thelanofficial.com/validate-token", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ token }),
        });

        if (!res.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await res.json();
        if (data.valid === false) {
          history.push("/auth/login");
        }
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    };

    fetchData();

  }, []);

  return (
    <>
      <Box component={Grid} container justifyContent="center">
        <Grid item xs={12} lg={6} md={8}>
          <Card classes={{ root: classes.cardRoot }}>
            <CardHeader
              className={classes.cardHeader}
              title={
                <Box
                  fontSize="200%"
                  fontWeight="800"
                  component="large"
                  color={theme.palette.gray[600]}
                >
                  CREATE COURSE
                </Box>
              }
              titleTypographyProps={{
                component: Box,
                textAlign: "center",
                marginBottom: "1rem!important",
                marginTop: ".5rem!important",
                fontSize: "1rem!important",
              }}
            ></CardHeader>
            <CardContent classes={{ root: classes.cardContent }}>
              <Box
                color={theme.palette.gray[600]}
                textAlign="center"
                marginBottom="1.5rem"
                marginTop=".5rem"
                fontSize="1rem"
              >

                
                <Box fontSize="80%" fontWeight="400" component="small">
                  Select teacher and fill in course name and description
                </Box>
              </Box>
              <Box style={{ display: "flex", direction: "col", gap: "5px" }}>
                

                <FormControl
                  variant="filled"
                  component={Box}
                  width="100%"
                  marginBottom="1.5rem!important"
                >
                  <FilledInput
                    autoComplete="off"
                    type="text"
                    name="course"
                    value={form.course}
                    onChange={handleChange}
                    placeholder="Course name"
                    startAdornment={
                      <InputAdornment position="start">
                        <School />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Box>

              <FormControl
                variant="filled"
                component={Box}
                width="100%"
                marginBottom="1.5rem!important"
              >
                <FilledInput
                  autoComplete="off"
                  type="text"
                  name="description"
                  value={form.description}
                  onChange={handleChange}
                  placeholder="Course description"
                  startAdornment={
                    <InputAdornment position="start">
                      <School />
                    </InputAdornment>
                  }
                />
              </FormControl>

              
           

              <Box
                fontStyle="italic"
                fontSize="1rem"
                color={theme.palette.gray[600]}
                marginBottom=".5rem"
              >
                <Box component="small" fontSize="80%">
                  <Box
                    component="span"
                    fontWeight="700"
                    color={theme.palette.success.main}
                  ></Box>
                </Box>
              </Box>

              <Typography
                style={{
                  color:
                    alertText === "New course created"
                      ? "green"
                      : "red",
                  fontSize: "10px",
                }}
              >
                {alertText}
              </Typography>

              <CardHeader
              className={classes.cardHeader}
              title={
                <Box
                  fontSize="200%"
                  fontWeight="800"
                  component="large"
                  color={theme.palette.gray[600]}
                >
                 
                </Box>
              }
              titleTypographyProps={{
                component: Box,
                textAlign: "center",
                marginBottom: "1rem!important",
                marginTop: ".5rem!important",
                fontSize: "1rem!important",
              }}
            ></CardHeader>

              <Box textAlign="center" marginTop="1.5rem" marginBottom="1.5rem">


                <Button
                  onClick={ChangeCLick}
                  variant="contained"
                  classes={{ root: classes.buttonContainedInfo }}
                >
                  Create Course
                </Button>
              </Box>

              
            </CardContent>


          </Card>

          
          <Grid container component={Box} marginTop="1rem">
            <Grid item xs={6} component={Box} textAlign="left"></Grid>
            <Grid item xs={6} component={Box} textAlign="right"></Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default Delete;
